import styled from "styled-components";
import { StyledGridColumnProps } from "./GridColumn.types";

const StyledGridColumn = styled.div<StyledGridColumnProps>`
	&.GridColumn {
		box-sizing: border-box;

		&--fit {
			flex-grow: 1;
		}
		&--12 {
			width: 100%;
		}
		&--11 {
			width: 91.6666%;
		}
		&--10 {
			width: 83.3333%;
		}
		&--9 {
			width: 75%;
		}
		&--8 {
			width: 66.6666%;
		}
		&--7 {
			width: 58.3333%;
		}
		&--6 {
			width: 50%;
		}
		&--5 {
			width: 41.6666%;
		}
		&--4 {
			width: 33.3333%;
		}
		&--3 {
			width: 25%;
		}
		&--2 {
			width: 16.6666%;
		}
		&--1 {
			width: 8.3333%;
		}
		&--0 {
			/*
        !important is considered a hack, but it has been used here to enforce
        that modifier --0 should always take precedence.
      */
			visibility: hidden !important;
			padding: 0 !important;
			height: 0 !important;
			width: 0 !important;
		}
	}
`;

export default StyledGridColumn;
